export const currencies = [
    { code: 'USD', name: 'US Dollar', symbol: '$', flag: 'us' },
    { code: 'EUR', name: 'Euro', symbol: '€', flag: 'eu' },
    { code: 'GBP', name: 'British Pound', symbol: '£', flag: 'gb' },
    { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ', flag: 'ae' },
    { code: 'EGP', name: 'Egyptian Pound', symbol: 'E£', flag: 'eg' },
    { code: 'PKR', name: 'Pakistani Rupee', symbol: 'Rs', flag: 'pk' },
    { code: 'INR', name: 'Indian Rupee', symbol: '₹', flag: 'in' },
    { code: 'SAR', name: 'Saudi Riyal', symbol: '﷼', flag: 'sa' },
    { code: 'QAR', name: 'Qatari Riyal', symbol: '﷼', flag: 'qa' },
    { code: 'OMR', name: 'Omani Rial', symbol: '﷼', flag: 'om' },
    { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك', flag: 'kw' },
    { code: 'BHD', name: 'Bahraini Dinar', symbol: 'د.ب', flag: 'bh' },
    { code: 'TRY', name: 'Turkish Lira', symbol: '₺', flag: 'tr' },
    { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', flag: 'ca' },
    { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', flag: 'au' },
    { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', flag: 'sg' },
    { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', flag: 'hk' },
    { code: 'JPY', name: 'Japanese Yen', symbol: '¥', flag: 'jp' },
    { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', flag: 'cn' },
    { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', flag: 'ch' },
    { code: 'RUB', name: 'Russian Ruble', symbol: '₽', flag: 'ru' },
    { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', flag: 'my' },
    { code: 'THB', name: 'Thai Baht', symbol: '฿', flag: 'th' },
    { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', flag: 'id' },
    { code: 'ZAR', name: 'South African Rand', symbol: 'R', flag: 'za' },
    { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', flag: 'br' },
    { code: 'MXN', name: 'Mexican Peso', symbol: '$', flag: 'mx' },
];

export const countries = [
    { code: 'af', name: 'Afghanistan',           flag: 'af', dialCode: '+93'  },
    { code: 'al', name: 'Albania',               flag: 'al', dialCode: '+355' },
    { code: 'dz', name: 'Algeria',               flag: 'dz', dialCode: '+213' },
    { code: 'ad', name: 'Andorra',               flag: 'ad', dialCode: '+376' },
    { code: 'ao', name: 'Angola',                flag: 'ao', dialCode: '+244' },
    { code: 'ag', name: 'Antigua and Barbuda',   flag: 'ag', dialCode: '+1'   },
    { code: 'ar', name: 'Argentina',             flag: 'ar', dialCode: '+54'  },
    { code: 'am', name: 'Armenia',               flag: 'am', dialCode: '+374' },
    { code: 'az', name: 'Azerbaijan',            flag: 'az', dialCode: '+994' },
    { code: 'bs', name: 'Bahamas',               flag: 'bs', dialCode: '+1'   },
    { code: 'bd', name: 'Bangladesh',            flag: 'bd', dialCode: '+880' },
    { code: 'bb', name: 'Barbados',              flag: 'bb', dialCode: '+1'   },
    { code: 'by', name: 'Belarus',               flag: 'by', dialCode: '+375' },
    { code: 'bz', name: 'Belize',                flag: 'bz', dialCode: '+501' },
    { code: 'bj', name: 'Benin',                 flag: 'bj', dialCode: '+229' },
    { code: 'bt', name: 'Bhutan',                flag: 'bt', dialCode: '+975' },
    { code: 'bo', name: 'Bolivia',               flag: 'bo', dialCode: '+591' },
    { code: 'ba', name: 'Bosnia and Herzegovina',flag: 'ba', dialCode: '+387' },
    { code: 'bw', name: 'Botswana',              flag: 'bw', dialCode: '+267' },
    { code: 'bn', name: 'Brunei',                flag: 'bn', dialCode: '+673' },
    { code: 'bg', name: 'Bulgaria',              flag: 'bg', dialCode: '+359' },
    { code: 'bf', name: 'Burkina Faso',          flag: 'bf', dialCode: '+226' },
    { code: 'bi', name: 'Burundi',               flag: 'bi', dialCode: '+257' },
    { code: 'cv', name: 'Cape Verde',            flag: 'cv', dialCode: '+238' },
    { code: 'kh', name: 'Cambodia',              flag: 'kh', dialCode: '+855' },
    { code: 'cm', name: 'Cameroon',              flag: 'cm', dialCode: '+237' },
    { code: 'cf', name: 'Central African Republic', flag: 'cf', dialCode: '+236' },
    { code: 'td', name: 'Chad',                  flag: 'td', dialCode: '+235' },
    { code: 'cl', name: 'Chile',                 flag: 'cl', dialCode: '+56'  },
    { code: 'co', name: 'Colombia',              flag: 'co', dialCode: '+57'  },
    { code: 'km', name: 'Comoros',               flag: 'km', dialCode: '+269' },
    { code: 'cg', name: 'Congo',                 flag: 'cg', dialCode: '+242' },
    { code: 'cd', name: 'Congo DR',              flag: 'cd', dialCode: '+243' },
    { code: 'cr', name: 'Costa Rica',            flag: 'cr', dialCode: '+506' },
    { code: 'ci', name: 'Cote dIvoire',          flag: 'ci', dialCode: '+225' },
    { code: 'hr', name: 'Croatia',               flag: 'hr', dialCode: '+385' },
    { code: 'cu', name: 'Cuba',                  flag: 'cu', dialCode: '+53'  },
    { code: 'cy', name: 'Cyprus',                flag: 'cy', dialCode: '+357' },
    { code: 'cz', name: 'Czech Republic',        flag: 'cz', dialCode: '+420' },
    { code: 'dj', name: 'Djibouti',              flag: 'dj', dialCode: '+253' },
    { code: 'dm', name: 'Dominica',              flag: 'dm', dialCode: '+1'   },
    { code: 'do', name: 'Dominican Republic',    flag: 'do', dialCode: '+1'   },
    { code: 'ec', name: 'Ecuador',               flag: 'ec', dialCode: '+593' },
    { code: 'sv', name: 'El Salvador',           flag: 'sv', dialCode: '+503' },
    { code: 'gq', name: 'Equatorial Guinea',     flag: 'gq', dialCode: '+240' },
    { code: 'er', name: 'Eritrea',               flag: 'er', dialCode: '+291' },
    { code: 'ee', name: 'Estonia',               flag: 'ee', dialCode: '+372' },
    { code: 'sz', name: 'Eswatini',              flag: 'sz', dialCode: '+268' },
    { code: 'et', name: 'Ethiopia',              flag: 'et', dialCode: '+251' },
    { code: 'fj', name: 'Fiji',                  flag: 'fj', dialCode: '+679' },
    { code: 'ga', name: 'Gabon',                 flag: 'ga', dialCode: '+241' },
    { code: 'gm', name: 'Gambia',                flag: 'gm', dialCode: '+220' },
    { code: 'ge', name: 'Georgia',               flag: 'ge', dialCode: '+995' },
    { code: 'gh', name: 'Ghana',                 flag: 'gh', dialCode: '+233' },
    { code: 'gd', name: 'Grenada',               flag: 'gd', dialCode: '+1'   },
    { code: 'gt', name: 'Guatemala',             flag: 'gt', dialCode: '+502' },
    { code: 'gn', name: 'Guinea',                flag: 'gn', dialCode: '+224' },
    { code: 'gw', name: 'Guinea-Bissau',         flag: 'gw', dialCode: '+245' },
    { code: 'gy', name: 'Guyana',                flag: 'gy', dialCode: '+592' },
    { code: 'ht', name: 'Haiti',                 flag: 'ht', dialCode: '+509' },
    { code: 'hn', name: 'Honduras',              flag: 'hn', dialCode: '+504' },
    { code: 'hu', name: 'Hungary',               flag: 'hu', dialCode: '+36'  },
    { code: 'is', name: 'Iceland',               flag: 'is', dialCode: '+354' },
    { code: 'ie', name: 'Ireland',               flag: 'ie', dialCode: '+353' },
    { code: 'ir', name: 'Iran',                  flag: 'ir', dialCode: '+98'  },
    { code: 'iq', name: 'Iraq',                  flag: 'iq', dialCode: '+964' },
    { code: 'il', name: 'Israel',                flag: 'il', dialCode: '+972' },
    { code: 'jm', name: 'Jamaica',               flag: 'jm', dialCode: '+1'   },
    { code: 'kz', name: 'Kazakhstan',            flag: 'kz', dialCode: '+7'   },
    { code: 'kg', name: 'Kyrgyzstan',            flag: 'kg', dialCode: '+996' },
    { code: 'la', name: 'Laos',                  flag: 'la', dialCode: '+856' },
    { code: 'lv', name: 'Latvia',                flag: 'lv', dialCode: '+371' },
    { code: 'lb', name: 'Lebanon',               flag: 'lb', dialCode: '+961' },
    { code: 'ls', name: 'Lesotho',               flag: 'ls', dialCode: '+266' },
    { code: 'lr', name: 'Liberia',               flag: 'lr', dialCode: '+231' },
    { code: 'ly', name: 'Libya',                 flag: 'ly', dialCode: '+218' },
    { code: 'lt', name: 'Lithuania',             flag: 'lt', dialCode: '+370' },
    { code: 'lu', name: 'Luxembourg',            flag: 'lu', dialCode: '+352' },
    { code: 'mg', name: 'Madagascar',            flag: 'mg', dialCode: '+261' },
    { code: 'mw', name: 'Malawi',                flag: 'mw', dialCode: '+265' },
    { code: 'mv', name: 'Maldives',              flag: 'mv', dialCode: '+960' },
    { code: 'ml', name: 'Mali',                  flag: 'ml', dialCode: '+223' },
    { code: 'mt', name: 'Malta',                 flag: 'mt', dialCode: '+356' },
    { code: 'mr', name: 'Mauritania',            flag: 'mr', dialCode: '+222' },
    { code: 'mu', name: 'Mauritius',             flag: 'mu', dialCode: '+230' },
    { code: 'md', name: 'Moldova',               flag: 'md', dialCode: '+373' },
    { code: 'mc', name: 'Monaco',                flag: 'mc', dialCode: '+377' },
    { code: 'mn', name: 'Mongolia',              flag: 'mn', dialCode: '+976' },
    { code: 'me', name: 'Montenegro',            flag: 'me', dialCode: '+382' },
    { code: 'ma', name: 'Morocco',               flag: 'ma', dialCode: '+212' },
    { code: 'mz', name: 'Mozambique',            flag: 'mz', dialCode: '+258' },
    { code: 'mm', name: 'Myanmar',               flag: 'mm', dialCode: '+95'  },
    { code: 'na', name: 'Namibia',               flag: 'na', dialCode: '+264' },
    { code: 'np', name: 'Nepal',                 flag: 'np', dialCode: '+977' },
    { code: 'ni', name: 'Nicaragua',             flag: 'ni', dialCode: '+505' },
    { code: 'ne', name: 'Niger',                 flag: 'ne', dialCode: '+227' },
    { code: 'mk', name: 'North Macedonia',       flag: 'mk', dialCode: '+389' },
    { code: 'pa', name: 'Panama',                flag: 'pa', dialCode: '+507' },
    { code: 'pg', name: 'Papua New Guinea',      flag: 'pg', dialCode: '+675' },
    { code: 'py', name: 'Paraguay',              flag: 'py', dialCode: '+595' },
    { code: 'pe', name: 'Peru',                  flag: 'pe', dialCode: '+51'  },
    { code: 'pl', name: 'Poland',                flag: 'pl', dialCode: '+48'  },
    { code: 'ro', name: 'Romania',               flag: 'ro', dialCode: '+40'  },
    { code: 'rw', name: 'Rwanda',                flag: 'rw', dialCode: '+250' },
    { code: 'kn', name: 'Saint Kitts and Nevis', flag: 'kn', dialCode: '+1'   },
    { code: 'lc', name: 'Saint Lucia',           flag: 'lc', dialCode: '+1'   },
    { code: 'vc', name: 'Saint Vincent and the Grenadines', flag: 'vc', dialCode: '+1' },
    { code: 'ws', name: 'Samoa',                 flag: 'ws', dialCode: '+685' },
    { code: 'sm', name: 'San Marino',            flag: 'sm', dialCode: '+378' },
    { code: 'st', name: 'Sao Tome and Principe', flag: 'st', dialCode: '+239' },
    { code: 'sn', name: 'Senegal',               flag: 'sn', dialCode: '+221' },
    { code: 'rs', name: 'Serbia',                flag: 'rs', dialCode: '+381' },
    { code: 'sc', name: 'Seychelles',            flag: 'sc', dialCode: '+248' },
    { code: 'sl', name: 'Sierra Leone',          flag: 'sl', dialCode: '+232' },
    { code: 'sk', name: 'Slovakia',              flag: 'sk', dialCode: '+421' },
    { code: 'si', name: 'Slovenia',              flag: 'si', dialCode: '+386' },
    { code: 'sb', name: 'Solomon Islands',       flag: 'sb', dialCode: '+677' },
    { code: 'so', name: 'Somalia',               flag: 'so', dialCode: '+252' },
    { code: 'ss', name: 'South Sudan',           flag: 'ss', dialCode: '+211' },
    { code: 'lk', name: 'Sri Lanka',             flag: 'lk', dialCode: '+94'  },
    { code: 'sd', name: 'Sudan',                 flag: 'sd', dialCode: '+249' },
    { code: 'sr', name: 'Suriname',              flag: 'sr', dialCode: '+597' },
    { code: 'sy', name: 'Syria',                 flag: 'sy', dialCode: '+963' },
    { code: 'tw', name: 'Taiwan',                flag: 'tw', dialCode: '+886' },
    { code: 'tj', name: 'Tajikistan',            flag: 'tj', dialCode: '+992' },
    { code: 'tz', name: 'Tanzania',              flag: 'tz', dialCode: '+255' },
    { code: 'tl', name: 'Timor-Leste',           flag: 'tl', dialCode: '+670' },
    { code: 'tg', name: 'Togo',                  flag: 'tg', dialCode: '+228' },
    { code: 'to', name: 'Tonga',                 flag: 'to', dialCode: '+676' },
    { code: 'tt', name: 'Trinidad and Tobago',   flag: 'tt', dialCode: '+1'   },
    { code: 'tn', name: 'Tunisia',               flag: 'tn', dialCode: '+216' },
    { code: 'tm', name: 'Turkmenistan',          flag: 'tm', dialCode: '+993' },
    { code: 'ug', name: 'Uganda',                flag: 'ug', dialCode: '+256' },
    { code: 'ua', name: 'Ukraine',               flag: 'ua', dialCode: '+380' },
    { code: 'uy', name: 'Uruguay',               flag: 'uy', dialCode: '+598' },
    { code: 'uz', name: 'Uzbekistan',            flag: 'uz', dialCode: '+998' },
    { code: 'vu', name: 'Vanuatu',               flag: 'vu', dialCode: '+678' },
    { code: 've', name: 'Venezuela',             flag: 've', dialCode: '+58'  },
    { code: 'ye', name: 'Yemen',                 flag: 'ye', dialCode: '+967' },
    { code: 'zm', name: 'Zambia',                flag: 'zm', dialCode: '+260' },
    { code: 'zw', name: 'Zimbabwe',              flag: 'zw', dialCode: '+263' },
    { code: 'pk', name: 'Pakistan',              flag: 'pk', dialCode: '+92'  },
    { code: 'gb', name: 'United Kingdom',         flag: 'gb', dialCode: '+44'  },
    { code: 'us', name: 'United States',          flag: 'us', dialCode: '+1'   },
    { code: 'ae', name: 'United Arab Emirates',   flag: 'ae', dialCode: '+971' },
    { code: 'sa', name: 'Saudi Arabia',           flag: 'sa', dialCode: '+966' },
    { code: 'ca', name: 'Canada',                 flag: 'ca', dialCode: '+1'   },
    { code: 'au', name: 'Australia',              flag: 'au', dialCode: '+61'  },
    { code: 'tr', name: 'Turkey',                 flag: 'tr', dialCode: '+90'  },
    { code: 'eg', name: 'Egypt',                  flag: 'eg', dialCode: '+20'  },
    { code: 'fr', name: 'France',                 flag: 'fr', dialCode: '+33'  },
    { code: 'de', name: 'Germany',                flag: 'de', dialCode: '+49'  },
    { code: 'it', name: 'Italy',                  flag: 'it', dialCode: '+39'  },
    { code: 'es', name: 'Spain',                  flag: 'es', dialCode: '+34'  },
    { code: 'pt', name: 'Portugal',               flag: 'pt', dialCode: '+351' },
    { code: 'gr', name: 'Greece',                 flag: 'gr', dialCode: '+30'  },
    { code: 'nl', name: 'Netherlands',            flag: 'nl', dialCode: '+31'  },
    { code: 'be', name: 'Belgium',                flag: 'be', dialCode: '+32'  },
    { code: 'ch', name: 'Switzerland',            flag: 'ch', dialCode: '+41'  },
    { code: 'at', name: 'Austria',                flag: 'at', dialCode: '+43'  },
    { code: 'no', name: 'Norway',                 flag: 'no', dialCode: '+47'  },
    { code: 'se', name: 'Sweden',                 flag: 'se', dialCode: '+46'  },
    { code: 'dk', name: 'Denmark',                flag: 'dk', dialCode: '+45'  },
    { code: 'fi', name: 'Finland',                flag: 'fi', dialCode: '+358' },
    { code: 'in', name: 'India',                  flag: 'in', dialCode: '+91'  },
    { code: 'id', name: 'Indonesia',              flag: 'id', dialCode: '+62'  },
    { code: 'my', name: 'Malaysia',               flag: 'my', dialCode: '+60'  },
    { code: 'th', name: 'Thailand',               flag: 'th', dialCode: '+66'  },
    { code: 'vn', name: 'Vietnam',                flag: 'vn', dialCode: '+84'  },
    { code: 'ph', name: 'Philippines',            flag: 'ph', dialCode: '+63'  },
    { code: 'jp', name: 'Japan',                  flag: 'jp', dialCode: '+81'  },
    { code: 'kr', name: 'South Korea',            flag: 'kr', dialCode: '+82'  },
    { code: 'cn', name: 'China',                  flag: 'cn', dialCode: '+86'  },
    { code: 'ru', name: 'Russia',                 flag: 'ru', dialCode: '+7'   },
    { code: 'qa', name: 'Qatar',                  flag: 'qa', dialCode: '+974' },
    { code: 'bh', name: 'Bahrain',                flag: 'bh', dialCode: '+973' },
    { code: 'kw', name: 'Kuwait',                 flag: 'kw', dialCode: '+965' },
    { code: 'om', name: 'Oman',                   flag: 'om', dialCode: '+968' },
    { code: 'jo', name: 'Jordan',                 flag: 'jo', dialCode: '+962' },
    { code: 'sg', name: 'Singapore',              flag: 'sg', dialCode: '+65'  },
    { code: 'hk', name: 'Hong Kong',              flag: 'hk', dialCode: '+852' },
    { code: 'za', name: 'South Africa',           flag: 'za', dialCode: '+27'  },
    { code: 'ng', name: 'Nigeria',                flag: 'ng', dialCode: '+234' },
    { code: 'ke', name: 'Kenya',                  flag: 'ke', dialCode: '+254' },
    { code: 'nz', name: 'New Zealand',            flag: 'nz', dialCode: '+64'  },
    { code: 'mx', name: 'Mexico',                 flag: 'mx', dialCode: '+52'  },
    { code: 'br', name: 'Brazil',                 flag: 'br', dialCode: '+55'  },
];

/**
 * Derived list for phone-dial-code selectors.
 * Sorted: most-common countries first, rest alphabetical.
 */
const PRIORITY = ['pk','gb','us','ae','sa','eg','in','ca','au','de','fr','tr','ru','qa','kw','om','bh','jo'];
export const phoneCodes = [
    ...PRIORITY.map(c => countries.find(x => x.code === c)).filter(Boolean),
    ...countries.filter(c => !PRIORITY.includes(c.code)).sort((a, b) => a.name.localeCompare(b.name)),
];
